const ENVIRONMENT_CONFIG = {
  domains: {
    development: ["localhost", "zyla.in"],
    production: ["zyla.in"],
    staging: ["zyla.in"],
  },
  vars: {
    // "dev1.bridge.zyla.in","dev2.bridge.zyla.in","feature.bridge.zyla.in","bridge.zyla.in","bridge.prod.zyla.in","sandbox.bridge.zyla.in"
    development: {
      apiUrl: "https://uat.api.zyla.in",
      domain: "orbit.uat.zyla.in",
      serviceUrl: "https://services.uat.zyla.in",
      serviceSocket: "wss://services.uat.zyla.in",
      serviceNew: "https://services.uat.zyla.in",
      localService: "https://services.uat.zyla.in",
      strapiUrl: "https://strapi.uat.zyla.in",
      // Chief-complaints v2 backend (api-cc-v2-service). Runs on localhost during
      // development until it ships to the gateway. Only phr talks to it directly.
      ccV2Url: "https://services.uat.zyla.in",
      // Diagnosis v2 backend (api-diagnosis-v2-service). Local on :8081 for
      // dev — update to the gateway URL once deployed.
      diagnosisV2Url: "https://services.uat.zyla.in",
      // Medicine v2 backend (api-medicine-v2-service). Local on :8082 for
      // dev — update to the gateway URL once deployed.
      medicineV2Url: "https://services.uat.zyla.in",
      // Addiction v2 backend (api-addiction-v2-service). Local on :8083 for
      // dev — update to the gateway URL once deployed.
      addictionV2Url: "https://services.uat.zyla.in",
      // Family History v2 backend (api-family-history-v2-service). Local on
      // :8084 for dev — update to the gateway URL once deployed.
      familyHistoryV2Url: "https://services.uat.zyla.in",
      // Physical Activity v2 backend (api-activity-v2-service). Local on
      // :8085 for dev — update to the gateway URL once deployed. Also serves
      // the activity fuzzy-search catalog under /api/v1/activity-catalog.
      activityV2Url: "https://services.uat.zyla.in",
      // Allergy v2 backend (api-allergy-v2-service). Local on :8086 for dev.
      // Federated catalog endpoint under /api/v1/allergen-catalog — proxies
      // drugs from api-medicine-service + own foods/other catalog.
      allergyV2Url: "https://services.uat.zyla.in",
      // Hospitalisation v2 backend (api-hospitalisation-v2-service). Local
      // on :8087 for dev. Federated CPT-procedure endpoint under
      // /api/v1/procedure-catalog — proxies api-hospitalisation-service.
      hospitalisationV2Url: "https://services.uat.zyla.in",
      // Lab investigation v2 backend (api-lab-investigation-v2-service).
      // Local on :8088 for dev. Federated /labtest-catalog + digitisation
      // proxy under /:patientId/documents + /:patientId/digitise.
      labInvestigationV2Url: "https://services.uat.zyla.in",
      // Anthropometric v2 backend (api-anthropometric-v2-service). Local
      // on :8089 for dev. Fetches patient DOB + gender per save (fail-
      // strict on monolith error) for pediatric BMI + waist/WHR flagging.
      anthropometricV2Url: "https://services.uat.zyla.in",
      // Food preferences v2 backend (api-food-preferences-v2-service).
      // Local on :8090 for dev. Review-only inline-edited single doc;
      // debounced save. Ingredients search proxied to api-recipes-service.
      foodPreferencesV2Url: "https://services.uat.zyla.in",
      // Daily schedule v2 backend (api-daily-schedule-v2-service). Local
      // on :8091 for dev. Timeline + hydration + sleep on one doc; server
      // seeds a 14-row default on first-load; StatusHistory per entry.
      dailyScheduleV2Url: "https://services.uat.zyla.in",
      // AI transcript v2 backend (api-ai-transcript-v2-service). Local on
      // :8092 for dev. Owns the whole call transcript lifecycle: past-
      // transcripts list, live turn append, AI-captured scratch buffer,
      // per-section Save-and-next commit. Consent-gated /captured.
      aiTranscriptV2Url: "https://services.uat.zyla.in",
      // localService: "http://localhost:8080",
    },
    production: {
      apiUrl: "//api.zyla.in",
      staticUrl: "//api.zyla.in",
      domain: "expert.zyla.in",
      serviceUrl: "//services.prod.zyla.in",
      serviceSocket: "wss://services.zyla.in",
      serviceNew: "//services.prod.zyla.in",
      localService: "//services.prod.zyla.in",
      strapiUrl: "https://strapi1.prod.zyla.in",
      // TODO: update when api-cc-v2-service is deployed to production
      ccV2Url: "//services.prod.zyla.in",
      // TODO: update when api-diagnosis-v2-service is deployed to production
      diagnosisV2Url: "//services.prod.zyla.in",
      // TODO: update when api-medicine-v2-service is deployed to production
      medicineV2Url: "//services.prod.zyla.in",
      // TODO: update when api-addiction-v2-service is deployed to production
      addictionV2Url: "//services.prod.zyla.in",
      // TODO: update when api-family-history-v2-service is deployed to production
      familyHistoryV2Url: "//services.prod.zyla.in",
      // TODO: update when api-activity-v2-service is deployed to production
      activityV2Url: "//services.prod.zyla.in",
      // TODO: update when api-allergy-v2-service is deployed to production
      allergyV2Url: "//services.prod.zyla.in",
      // TODO: update when api-hospitalisation-v2-service is deployed to production
      hospitalisationV2Url: "//services.prod.zyla.in",
      // TODO: update when api-lab-investigation-v2-service is deployed to production
      labInvestigationV2Url: "//services.prod.zyla.in",
      // TODO: update when api-anthropometric-v2-service is deployed to production
      anthropometricV2Url: "//services.prod.zyla.in",
      // TODO: update when api-food-preferences-v2-service is deployed to production
      foodPreferencesV2Url: "//services.prod.zyla.in",
      // TODO: update when api-daily-schedule-v2-service is deployed to production
      dailyScheduleV2Url: "//services.prod.zyla.in",
      // TODO: update when api-ai-transcript-v2-service is deployed to production
      aiTranscriptV2Url: "//services.prod.zyla.in",
    },
    staging: {
      apiUrl: "https://dev1.api.zyla.in",
      domain: "dev1.bridge.zyla.in",
      serviceUrl: "https://services.dev1.zyla.in",
      serviceSocket: "wss://services.dev1.zyla.in",
      serviceNew: "https://services.dev1.zyla.in",
      localService: "https://services.dev1.zyla.in",
      strapiUrl: "https://strapi.dev1.zyla.in",
      // TODO: update when api-cc-v2-service is deployed to staging
      ccV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-diagnosis-v2-service is deployed to staging
      diagnosisV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-medicine-v2-service is deployed to staging
      medicineV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-addiction-v2-service is deployed to staging
      addictionV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-family-history-v2-service is deployed to staging
      familyHistoryV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-activity-v2-service is deployed to staging
      activityV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-allergy-v2-service is deployed to staging
      allergyV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-hospitalisation-v2-service is deployed to staging
      hospitalisationV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-lab-investigation-v2-service is deployed to staging
      labInvestigationV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-anthropometric-v2-service is deployed to staging
      anthropometricV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-food-preferences-v2-service is deployed to staging
      foodPreferencesV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-daily-schedule-v2-service is deployed to staging
      dailyScheduleV2Url: "https://services.dev1.zyla.in",
      // TODO: update when api-ai-transcript-v2-service is deployed to staging
      aiTranscriptV2Url: "https://services.dev1.zyla.in",
    },
  },
  environments: {
    development: "development",
    production: "production",
    staging: "staging",
  },
};

export default ENVIRONMENT_CONFIG;
